module.exports = __webpack_public_path__ + "img/david_michelangelo_hero_bg.a0344f42.png";